import {
  INITIATE_LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  REQUEST_CURRENT_STATE,
  SAVE_TOKEN,
} from "./loginActionTypes";

export default function reducer(state = [], action) {
  switch (action.type) {
    case LOGOUT:
      console.log("Logging out...");
      return {
        user: {
          login: false,
        },
        userData: {},
      };
    case INITIATE_LOGIN:
      return {
        ...action.data,
      };
    case REQUEST_CURRENT_STATE:
      return state;
    case SAVE_TOKEN:
      return {
        ...state,
        forgetPasswordToken: action.forgetPasswordToken,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        user: {
          login: true,
        },
      };
    default:
      return state;
  }
}
